import React from "react";
import webui from "@tinqin/tinqin-web-ui";
import {
    applyLinesRestriction,
    traverseAndApplyUnderlineColor
} from "../../common/utils/InlineStyles";
import ResponsiveHOC from "../../HOC/components/responsive";
import { xssFilter } from "../../common/utils/xssFilter";

class RestrictedRichText extends React.Component {
    constructor(props) {
        super(props);
        this.content = React.createRef();
    }
    componentDidMount() {
        const node = this.content.current;
        if (node) {
            const props = this.getProps();
            traverseAndApplyUnderlineColor(node);
            applyLinesRestriction(node, props.allowedLines);
        }
    }

    componentDidUpdate() {
        const node = this.content.current;
        if (node) {
            const props = this.getProps();
            traverseAndApplyUnderlineColor(node);
            applyLinesRestriction(node, props.allowedLines);
        }
    }
    getProps() {
        return webui.getUtils().extractComponentProps(this.props, {
            additionalProps: ["tag", "value", "extraClasses", "sizes", "allowedLines"],
            propsDefaults: {
                tag: "div",
                extraClasses: "",
                allowedLines: 2
            }
        });
    }
    render() {
        const data = this.props.data ? this.props.data.properties || {} : null;
        if (!data) {
            return "";
        }
        const dataProps = this.getProps();
        return React.createElement(dataProps.tag, {
            className: dataProps.extraClasses,
            dangerouslySetInnerHTML: {
                __html: xssFilter.process(dataProps.value)
            },
            ref: this.content,
            "data-hyperlinks-container": true
        });
    }
}

//using additional wrapper in order to take configuration of responsiveContainer
//and apply it to the ResponsiveHOC
function ResponsiveHOCWrapper(props) {
    const dataProps = webui.getUtils().extractComponentProps(props, {
        additionalProps: ["sizes"]
    });
    const sizesOptions = dataProps.sizes ? { sizes: dataProps.sizes } : undefined;
    const HOCComponent = ResponsiveHOC(RestrictedRichText, sizesOptions);
    return <HOCComponent {...props}></HOCComponent>;
}

export default webui.connectComponent()(ResponsiveHOCWrapper);
